
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'signature-col',

  props: {
    nguoiKy: {
      type: String,
      default: '',
    },
    thongTin: {
      type: String,
      default: '(Ký, họ tên)',
    },
    name: {
      type: String,
      default: ''
    }
  },
});
